module.exports = __webpack_public_path__ + "img/01-capsule-2.51b8e8c2.svg";